/* Shinyaku — desktop wheel momentum smoothing.
   Native scrolling is preserved on touch devices, inside drawers/modals/inner
   scrollareas, while a dialog is open or scroll is locked, and for users with
   prefers-reduced-motion. Keyboard, scrollbar drags and touch always stay native. */
(function () {
  if (!window.matchMedia) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var EASE = 0.14;
  var target = null;
  var current = null;
  var raf = null;
  var activeScroller = null;

  function getScroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw) {
      var cs = getComputedStyle(pw);
      if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && pw.scrollHeight > pw.clientHeight + 1) return pw;
    }
    return document.scrollingElement || document.documentElement;
  }

  function scrollableAncestor(node, stopAt) {
    var el = node instanceof Element ? node : node && node.parentElement;
    while (el && el !== stopAt && el !== document.body && el !== document.documentElement) {
      var cs = getComputedStyle(el);
      if (/(auto|scroll)/.test(cs.overflowY) && el.scrollHeight > el.clientHeight + 1) return el;
      el = el.parentElement;
    }
    return null;
  }

  function stop() {
    if (raf) cancelAnimationFrame(raf);
    raf = null;
    target = null;
    current = null;
    if (activeScroller) {
      activeScroller.style.scrollBehavior = '';
      activeScroller = null;
    }
  }

  function tick() {
    raf = requestAnimationFrame(function () {
      if (!activeScroller || target === null) { stop(); return; }
      current += (target - current) * EASE;
      if (Math.abs(target - current) < 0.6) {
        activeScroller.scrollTop = target;
        stop();
        return;
      }
      activeScroller.scrollTop = current;
      tick();
    });
  }

  window.addEventListener('wheel', function (e) {
    if (e.ctrlKey || e.defaultPrevented) return;
    if (document.documentElement.hasAttribute('scroll-lock')) return;
    if (document.querySelector('dialog[open]')) return;

    var sc = getScroller();
    var stopAt = (sc === document.scrollingElement || sc === document.documentElement) ? document.documentElement : sc;
    var inner = scrollableAncestor(e.target, stopAt);
    if (inner && inner !== sc) return;

    var max = sc.scrollHeight - sc.clientHeight;
    if (max <= 0) return;

    var delta = e.deltaY;
    if (e.deltaMode === 1) delta *= 16;
    else if (e.deltaMode === 2) delta *= sc.clientHeight;

    e.preventDefault();

    if (sc !== activeScroller && activeScroller) stop();
    if (target === null) {
      current = sc.scrollTop;
      target = sc.scrollTop;
    }
    activeScroller = sc;
    sc.style.scrollBehavior = 'auto'; /* our per-frame writes must be instant */
    target = Math.max(0, Math.min(max, target + delta));
    if (!raf) tick();
  }, { passive: false });

  /* Hand control back the moment the user scrolls another way */
  window.addEventListener('keydown', stop, { passive: true });
  window.addEventListener('mousedown', stop, { passive: true });
  window.addEventListener('touchstart', stop, { passive: true });
})();
